var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shadow h-8 w-8 flex justify-center items-center rounded",class:_vm.getClasses,attrs:{"title":_vm.title},on:{"click":function($event){_vm.disabled ? null : _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }